import {Budget, BudgetRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell, useTheme} from "@mui/material";
import {COLOR_DISMISSED} from "../../../../components/layout/colors";


export const BudgetListPage = () => {
	const apiManager = useApiManager();
	const ctrl = apiManager.factory(BudgetRestControllerApiFactory);
	const theme = useTheme();

	const getBudgetColor = (budget: Budget): string => {
		if (budget.dismissed) {
			return COLOR_DISMISSED;
		}
		return theme.palette.warning.main;
	}

	const listConfig: AppListConfig<Budget> = {
		title: "Listado de Presupuestos",
		onClick: "/app/admin/billing/budget",
		headers: [
			{title: "Completado"},
			{title: "Cliente"},
			{title: "Nombre", width: "25%"},
			{title: "Responsable"},
			{title: "Unidad"},
			{title: "Desde/Hasta"},
			{title: "Justificación", width: "7%"},
			{title: "Horas", align: "right", width: "7%"},
		],
		decorator: (bean: Budget) => (
			<>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					{bean.completed ? "Completado" : ""}
				</TableCell>
				<TableCell style={{color: bean.dismissed ? COLOR_DISMISSED : ""}}>
					({bean.customer.id}) {bean.customer.shortName || "---"}
				</TableCell>
				<TableCell
					style={{color: getBudgetColor(bean), overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					({bean.id}) {bean.title}
				</TableCell>
				<TableCell style={{overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap"}}>
					{bean.owner?.surnamesAndName}
				</TableCell>
				<TableCell>
					{bean.organizationUnit?.name}
				</TableCell>
				<TableCell>
					{bean.startDate || "..."} / {bean.endDate || "..."}
				</TableCell>
				<TableCell align={"center"}>
					{(bean.customerAcceptance || "").length > 0 ? "Sí" : <span style={{color: "red"}}>No</span>}
				</TableCell>
				<TableCell style={{textAlign: "right"}}>
					{bean.totalHours || "---"}
				</TableCell>
			</>
		),
		supplier: async (currentPage, size, term, showDismissed) => {
			return ctrl.pageBudget(
				currentPage,
				size,
				undefined,
				term,
				showDismissed
			);
		}
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};
